"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSubEntriesRecursively = void 0;
const mapSubEntriesRecursively = (entries) => !entries
    ? []
    : entries.map((entry) => {
        var _a;
        const subEntries = (_a = entry.facet) === null || _a === void 0 ? void 0 : _a.entries;
        return {
            name: entry.name,
            slugName: entry.slugName,
            subEntries: !(subEntries === null || subEntries === void 0 ? void 0 : subEntries.length) ? null : (0, exports.mapSubEntriesRecursively)(subEntries),
        };
    });
exports.mapSubEntriesRecursively = mapSubEntriesRecursively;
